(function (upp, window, navigator) {
    'use strict';

    upp.service('cartService', ['appi', 'order', '$q', 'product', 'storage', '$rootScope',
        function (appi, Order, $q, Product, storage, $rootScope) {
            /**
             * Wrapper around localStorage to get elements
             * @param {String} k The key of the element
             * @return {*} returns the element for the given key or undefined
             * @private
             */
            var _get = function (k) {
                if (navigator.userAgent.indexOf('PhantomJS') !== -1 || navigator.userAgent === undefined) {
                    return undefined;
                }

                var item = storage.get(k);

                if (item === 'undefined' || item === null) return undefined;
                return item;
            };

            /**
             * Wrapper around localStorage to set elements
             * @param {String} k Key for the saved element
             * @param {*} v Saved element
             * @private
             */
            var _set = function (k, v) {
                if (navigator.userAgent.indexOf('PhantomJS') !== -1 || navigator.userAgent === undefined) {
                    return undefined;
                }

                if ((typeof v) === 'object') {
                    v = JSON.stringify(v);

                    if (v === '{}' || v === '[]') v = undefined;
                }
                storage.set(k, v);
            };

            /**
             * Returns the current saved cart if it has been saved and it has not expired
             * @returns {*} The cart or undefined
             * @private
             */
            var _getStoredCart = function () {
                var order = _get('order'),
                    saved = Number(_get('saveDate')),
                    now = new Date().getTime();


                if (order === undefined || ((saved / 1000) + 86400) <= (now / 1000)) {
                    _set('order', undefined);
                    return undefined;
                }

                return JSON.parse(order);
            };

            /**
             * Updates the stored cart
             * @private
             */
            var _updateCart = function (order) {
                _set('order', order);
                _set('saveDate', new Date().getTime());
            };

            var ESHOP_URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "eshop/",
                PAYMENT_URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "payment/",
                $PAYMENT_MODELS = [1, 2, 3, 4, 5],
                $PAYMENT_PAYPAL = 1,
                $PAYMENT_REFUND = 2,
                $PAYMENT_WIRE_TRANSFER = 3,
                $PAYMENT_REDSYS = 4,
                $PAYMENT_PICK_AT_STORE = 5,
                module = "cart",
                _forEach = angular.forEach,

                order = (function () {
                    var orderStored = _getStoredCart(),
                        order = new Order();

                    if (orderStored) {
                        order.setId(orderStored.id);
                        order.products = orderStored.products;
                        if (orderStored.currency)
                            order.initCurrency(orderStored.currency);

                        window.setTimeout(function () {
                            updateNavBarCount();
                        }, 400);
                    }

                    return order;
                })();

            //Report the user with a modal dialog that the product has been added
            var _reportUser = (function () {
                var message = function (amount, goToCartCallback) {
                    return {
                        message: {
                            key: "CART.PRODUCT-ADDED",
                            pluralize: amount
                        },
                        closeButton: {
                            text: "CART.CONTINUE"
                        },
                        confirmButton: {
                            text: "CART.GO-TO-CART",
                            callback: goToCartCallback
                        }
                    };
                };

                var goToCart = (function () {
                    var _path = appi.location.path;

                    return function () {
                        _path("/cart");
                    }
                })();

                return function (amount) {
                    appi.ui.modalMessage(message(amount, goToCart))
                        .then(function(modal){
                            modal.show();
                        });
                }
            })();

            /**
             * Request the app to change the text of the nav bar, to show the actual amount of selected stock
             *
             * @method updateNavBarCount
             */
            var updateNavBarCount = function () {
                appi.ui.changeNavText(module, order.getSelectedStock() );
            };

            /**
             * Add a product to the order, update the cart count, and report the user that the product has been added,
             * returning a show() function for that.
             * Also emits on the root scope the event of cart.product.added
             *
             * @method add
             * @param {Object} product Product to be added to the order with:
             * selectedVariation:
             *      price: the original price
             *      priceFinal: the final price with promotion (if not promotion this value must be the same as the price)
             *      stock: -1 if infinite
             * @param {Object} currency Currency
             * @return {Function} to show a report dialog
             */
            var add = function (product, currency) {
                order.initCurrency(currency);
                order.addProduct(product);
                updateNavBarCount();
                _updateCart(order);
                $rootScope.$emit('cart.product.added', {
                    product: product,
                    currency: currency
                });

                return function show() {
                    _reportUser(product.selectedStock);
                };

            };

            /**
             * Remove a product for the order, and update the cart count in the nav bar
             *
             * @method remove
             * @param {Object} product Product to remove from the order
             */
            var remove = function (product) {
                order.removeProduct(product);
                updateNavBarCount();
                _updateCart(order);
                // update the car in the api service to restore the stock!
                updateCart(undefined);

                $rootScope.$emit('cart.product.removed', {
                    product: product
                });
            };

            /**
             * Update the stored cart and the navbar
             */
            var update = function () {
                updateNavBarCount();
                _updateCart(order);
            };

            /**
             * Returns the order
             *
             * @method getOrder
             * @return {Object} Returns the order object
             */
            var getOrder = function () {
                return order;
            };

            /**
             * Returns the currency object
             *
             * @method getCurrency
             * @return {Object} Returns the currency
             */
            var getCurrency = function () {
                return order.getCurrency();
            };

            // Returns the prices of a product
            var _getProductPrice = function (productId, attributeId, prices) {
                var x = 0,
                    length = prices.length,
                    price,
                    it;

                for (; x < length; x++) {
                    it = prices[x];
                    if (it.idProduct === productId && it.idAttribute === attributeId) {
                        price = {
                            unitPriceWithTaxes: it.pricePerUnitWithTaxes,
                            unitPrice: it.pricePerUnitWithoutTaxes,
                            totalPriceWithTaxes: it.priceWithTaxes,
                            totalPrice: it.priceWithoutTaxes,

                            amount: it.number
                        };
                        break;
                    }
                }

                return price;
            };

            // Returns an array of the products of the order and the price of each one.
            // The server gives back only the prices of the products, and the products are in memory, so here are joined
            var _getProductsWithPrices = function (products, prices) {
                _forEach(products, function (product) {
                    product.prices = _getProductPrice(product.id, product.selectedVariation.id, prices);
                });
                return products;
            };

            /**
             *
             * @returns {Promise} Returns a promise that will be fulfilled(Object with the totalPrice) or rejected(error)
             */
            var retrieveTotalPrice = function () {
                return appi.http.postSecure(ESHOP_URL_API_REST_SERVER + "order/prices", {
                        idOrder: order.getId()
                    });
            };

            /**
             * Returns the distribution of prices
             *
             * @method retrievePrices
             * @return {Promise} Returns a promise that will be fulfilled(Object with the products of the order and the currency) or rejected(error)
             */
            var retrieveOrderList = function () {
                var promise,
                    products = order.getProducts();
                if ( products && products.length) {
                    promise = appi.http.post(ESHOP_URL_API_REST_SERVER + "price", {
                            products: order.getProductsToCheckStock()
                        }
                    );
                    promise.success(function (response) {
                        response.order = _getProductsWithPrices(products, response.productPrice);
                        order.currency = response.currency;
                        _updateCart(order);
                    });
                } else {
                    var deferred = $q.defer();
                    deferred.resolve({data: {cartIsEmpty: true}});
                    return deferred.promise;
                }

                return promise;
            };

            var updateCart = function(id){
                var deferred = $q.defer();

                appi.http.postSecure(ESHOP_URL_API_REST_SERVER + "cart", {
                    products: order.getProductsToCheckStock(),
                    idOrder: order.getId(),
                    shippingChargeId: id

                })
                    .success(function (response) {
                        order.setPrice(response.price);
                        deferred.resolve(order);
                    });

                return deferred.promise;
            };

            /**
             * Check with the server the availability of the actual order
             *
             * @method checkStock
             * @return {Promise} Returns a promise that will be fulfilled(Object with the status of the cart) or rejected(error)
             */
            var checkStock = function () {
                var deferred = $q.defer();

                appi.http.postSecure(ESHOP_URL_API_REST_SERVER + "cart", {
                    products: order.getProductsToCheckStock(),
                    idOrder: order.getId()
                })
                    .success(function (response) {
                        //INFO stored in the "order"
                        order.setId(response.idOrder);
                        order.setPrice(response.price);
                        order.setFreeShippingCharges(response.freeShippingCharges);
                        order.setShippingAddress(response.shippingAddress);
                        order.setBillingAddress(response.billingAddress);
                        order.setAllowsShipping(response.allowsShipping);
                        order.setUnavailable(response.unavailable);

                        // Set the availability of the different payment methods
                        order.setRedsys(response.redsys);
                        order.setPayPal(response.payPal);
                        order.setRefund(response.refund);
                        order.setWireTransfer(response.wireTransfer);
                        order.setPickAtStore(response.pickAtStore);

                        order.setMinimumOrder(response.minimumOrder ? response.minimumOrder : 0);

                        order.currency = response.currency;

                        _updateCart(order);

                        deferred.resolve(order);
                    });

                return deferred.promise;
            };

            /**
             * Check if the order is ok (has products) for the 'address' controller
             *
             * @method checkOrder
             * @return {Boolean} Returns true if the order has products
             */
            var checkOrder = function () {
                return order.getProducts().length > 0;
            };

            /**
             * Get REST endpoint for the payment model
             *
             * @param {Number} paymentModel The payment model
             * @param {Number} orderId Id of the order
             * @private
             * @return {String} The REST endpoint for the selected payment model
             */
            var _getUrlForPaymentModel = function (paymentModel, orderId) {
                var endpoint;

                switch (paymentModel) {
                    case $PAYMENT_REFUND:
                        endpoint = 'refundset';
                        break;
                    case $PAYMENT_PAYPAL:
                        endpoint = 'paypalset';
                        break;
                    case $PAYMENT_REDSYS:
                        endpoint = 'redsys/prepare';
                        break;
                    case $PAYMENT_PICK_AT_STORE:
                        endpoint = 'pickatstore';
                        break;
                    case $PAYMENT_WIRE_TRANSFER:
                    default:
                        endpoint = 'wiretransferset';
                }

                return PAYMENT_URL_API_REST_SERVER + endpoint + '/' + orderId;
            };

            /**
             * Call de API REST via POST to start the payment process
             *
             * @method pay
             * @return {promise} Returns a promise that will be fulfilled(Url to open) or rejected(error)
             */
            var pay = function () {
                var url = _getUrlForPaymentModel(order.getPaymentModel(), order.id);
                return appi.http.postSecure(url, {
                    shippingAddress: order.getShippingAddress(),
                    billingAddress: order.getBillingAddress(),
                    comments: order.getObservations(),
                    paymentModel: order.getPaymentModel(),
                    pickAtStoreOption: order.getPickAtStoreOption()
                });
            };

            /**
             * Empty the order and update the navbar
             *
             * @method emptyOrder
             */
            var emptyCart = function () {
                order = new Order();
                updateNavBarCount();
                _updateCart(undefined);
                $rootScope.$emit('cart.cleared');
            };

            /*
             * Whenever any event emmited by is is recieved on the root scope, also emit a common one
             */
            var emitCommonEvent = function(ev) {
                $rootScope.$emit('cart.updated', ev);
            };
            $rootScope.$on('cart.product.added', emitCommonEvent);
            $rootScope.$on('cart.product.removed', emitCommonEvent);
            $rootScope.$on('cart.cleared', emitCommonEvent);

            return {
                add: add,
                remove: remove,
                update: update,
                getOrder: getOrder,
                retrieveOrderList: retrieveOrderList,
                retrieveTotalPrice: retrieveTotalPrice,
                getCurrency: getCurrency,
                updateNavBarCount: updateNavBarCount,
                checkStock: checkStock,
                checkOrder: checkOrder,
                pay: pay,
                emptyCart: emptyCart,
                updateCart: updateCart,
                $PAYMENT_MODELS: $PAYMENT_MODELS,
                $PAYMENT_PAYPAL: $PAYMENT_PAYPAL,
                $PAYMENT_REFUND: $PAYMENT_REFUND,
                $PAYMENT_WIRE_TRANSFER: $PAYMENT_WIRE_TRANSFER,
                $PAYMENT_REDSYS: $PAYMENT_REDSYS,
                $PAYMENT_PICK_AT_STORE: $PAYMENT_PICK_AT_STORE
            };
        }]);

})(upp, window, navigator);



// WEBPACK FOOTER //
// ./src/app/modules/cart/services/cart-services.js